/**
 * Utility for formatting cost, revenue, price, and currency values
 * according to Australian standards (comma-separated thousands, e.g., 1,000,000).
 */

/**
 * Formats a number or numeric string into Australian standard comma-separated format.
 * Examples:
 *   "1000"       => "1,000"
 *   "1000000"    => "1,000,000"
 *   "1234567.89" => "1,234,567.89"
 */
export const formatCostAustralian = (value) => {
  if (value === null || value === undefined || value === "") return "";

  const str = String(value);
  // Keep digits and decimal point
  const cleanStr = str.replace(/[^0-9.]/g, "");
  if (!cleanStr) return "";

  const parts = cleanStr.split(".");
  let integerPart = parts[0];

  // Insert comma separators every 3 digits from the right (standard Australian format)
  integerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ",");

  if (parts.length > 1) {
    const decimalPart = parts.slice(1).join("").slice(0, 2);
    return `${integerPart}.${decimalPart}`;
  }

  return integerPart;
};

/**
 * Strips commas from a formatted cost string to return clean numeric string for API submission or validation.
 * Example: "1,000,000.50" => "1000000.50"
 */
export const unformatCostNumber = (value) => {
  if (value === null || value === undefined || value === "") return "";
  return String(value).replace(/,/g, "");
};

/**
 * Determines whether a given form field or field metadata represents a cost, revenue, price, budget, or financial estimate.
 */
export const isCostOrRevenueField = (field) => {
  if (!field) return false;

  const fieldName = (typeof field === "string" ? field : field.FieldName || field.fieldName || field.name || "").toLowerCase();
  const fieldLabel = (typeof field === "object" ? field.FieldLabel || field.fieldLabel || field.label || field.DisplayName || field.placeholder || "" : "").toLowerCase();
  const inputType = (typeof field === "object" ? field.HtmlInputType || field.htmlInputType || field.type || "" : "").toLowerCase();

  if (inputType === "currency" || inputType === "cost") return true;

  const normFieldName = fieldName.replace(/[\s._-]/g, "");
  const normFieldLabel = fieldLabel.replace(/[\s._-]/g, "");

  const keywords = [
    "maxestimatedrevenue",
    "minestimatedrevenue",
    "maxestrevenue",
    "minestrevenue",
    "estrevenue",
    "estimatedrevenue",
    "estcost",
    "estimatedcost",
  ];

  return keywords.some((kw) => normFieldName.includes(kw) || normFieldLabel.includes(kw));
};
